'use client'
import {createContext} from "react";
import {RepositoryRegistry} from "@web-libs/core/repositories/application/repository-registry";
import {useContextStrict} from "@web-libs/core/context/context.functions";

export const RepositoryContext = createContext<RepositoryRegistry|null>(null)
RepositoryContext.displayName = 'RepositoryContext'

export const useRepositoryContext = () => {
    return useContextStrict(RepositoryContext)
}
